import { Component, OnChanges, Input } from '@angular/core';
import {
	PARAM_LABEL_BENEFICIAIRE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';

@Component({
	selector: 'app-activity-report-detail',
	templateUrl: './activity-report-detail.component.html',
	styleUrls: ['./activity-report-detail.component.scss']
})
export class ActivityReportDetailComponent implements OnChanges {
	@Input() statsEmployee: any[];
	@Input() categorie = '0';
	@Input() reportType: string;

	isReportByBeneficiaire: boolean;

	selectedWeek: number;
	tempsDeTravailTotal = '00:00';
	tempsFaceAFace = '00:00';
	tempsTrajet = '00:00';
	tempsAdministratifAndPreparation = '00:00';
	employee: any;
	total = {
		nbTotalFormation: 0,
		nbTotalDistanceParcourue: 0,
		nbTotalTempsFaceAFace: 0,
		nbTotalTempsTrajet: 0,
		nbTotalTempsAdministratifAndPreparation: 0,
		nbTotalTempsDeTravailTotal: 0
	};
	mapCompetence = {
		0: 'Global',
		1: 'LPC',
		2: 'LSF',
		3: 'PRISE_DE_NOTES',
		4: 'ORAL'
	};

	labelIntervenantCapitalized: string;
	labelInterventionCapitalizedPluralized: string;

	labelBeneficiaireCapitalized: string;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	constructor(public dateUtils: DateUtils, private facade: FacadeService) {
		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();

		this.isReportByBeneficiaire =
			this.reportType === 'Bénéficiaire' ? true : false;
		this.labelIntervenantCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelInterventionCapitalizedPluralized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENTION
			);
		this.labelBeneficiaireCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_BENEFICIAIRE
			);
	}

	ngOnChanges(change: any) {
		this.isReportByBeneficiaire =
			this.reportType === 'Bénéficiaire' ? true : false;
	}
}
